export default __webpack_public_path__ + "pgnv-assets/b9a4cad341c7c768ab336ede3831af77.svg";